import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    fishboneDiagram: {
        width: "100%",
        position: "relative",
    },
    mainHorizontalLine: {
        position: "absolute",
        width: "calc(90% - 115px)",
        height: theme.spacing(1),
        background: "#8D92B1",
        left: "47%",
        transform: "translateX(-50%)",
    },
    mainHorizontalLineWrapper: {
        width: "100%",
        height: "100%",
        position: "relative",
    },
    category: {},
    verticalLine: {
        position: "absolute",
        width: "4px",
        height: "120px",
        background: "#8D92B1",
    },
    arrowRight: {
        position: "absolute",
        top: "calc(50% - 12px)",
        right: "calc(0% - 3px)",
        borderTop: "12px solid transparent",
        borderBottom: "12px solid transparent",
        borderLeft: "18px solid #8D92B1",
    },
    head: {
        position: "absolute",
        right: "-117px",
        top: "calc(50% - 65px)",
        width: "128px",
        height: "128px",
    },
    headContent: {
        position: "relative",
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
        "&:hover": {
            "& > #headEditButton": {
                display: "flex",
            },
        },
        cursor: "default",
    },
    headTitle: {
        top: "-10px",
        position: "absolute",
        left: "20px",
        fontSize: "12px",
        fontWeight: "bold",
        fontFamily: "Source Sans 3",
    },
    headDescription: {
        position: "absolute",
        fontSize: "10px",
        width: "70%",
        top: "5px",
        left: "20px",
    },
    tooltip: {
        "&.MuiTooltip-popper .MuiTooltip-tooltip": {
            backgroundColor: theme.palette.secondary.main,
        },
    },
    tooltipTexts: {
        "&.MuiTypography-root": {
            fontSize: "10px",
            textAlign: "left",
            color: theme.palette.text.primary,
            fontWeight: 600,
            fontFamily: "Source Sans 3",
            paddingBottom: "5px",
        },
    },
    tail: {
        position: "absolute",
        top: "calc(50% - 60px)",
        left: "calc(0% - 63px)",
    },
    verticalLineWrapper: {
        width: "100%",
        height: "100%",
        position: "relative",
    },
    arrowDown: {
        position: "absolute",
        top: "calc(100% - 16px)",
        left: "calc(50% - 12px)",
        borderTop: "18px solid #8D92B1",
        borderLeft: "12px solid transparent",
        borderRight: "12px solid transparent",
    },
    arrowUp: {
        position: "absolute",
        top: "calc(100% - 18px)",
        left: "calc(50% - 12px)",
        borderTop: "18px solid #8D92B1",
        borderLeft: "12px solid transparent",
        borderRight: "12px solid transparent",
    },
    categoryName: {
        position: "absolute",
        padding: "12px",
        background: "#257BA0",
        width: "125px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: "10000px",
        transform: "translateX(-50%)",
    },
    categoryNameDown: {
        position: "absolute",
        padding: "12px",
        background: "#257BA0",
        width: "125px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: "10000px",
        transform: "translateX(-50%) rotate(180deg)",
    },
    categoryNameWrapper: {
        position: "relative",
        width: "100%",
        height: "100%",
    },
    categoryNameAddButton: {
        position: "absolute",
        top: "2px",
        left: "-20px",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        "& svg": {
            fontSize: "16px",
        },
    },
    categoryNameText: {
        fontSize: "14px",
        fontFamily: "Source Sans 3",
    },
    mainItem: {
        position: "absolute",
        background: "#F9C13D",
        width: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: "10000px",
        left: "50%",
        fontsize: "12px",
        boxSizing: "border-box !important" as any,
        "&:hover": {
            zIndex: 9999,
            "& > #itemDeleteButton": {
                display: "block",
            },
            "& > #itemEditButton": {
                display: "block",
            },
            "& > #itemHighlightButton": {
                display: "flex",
            },
        },
        cursor: "default",
    },
    mainItemHighlighted: {
        position: "absolute",
        background: "#F9C13D",
        width: "150px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: "10000px",
        left: "50%",
        fontsize: "12px",
        boxSizing: "border-box !important" as any,
        "&:hover": {
            zIndex: 9999,
            "& > #itemDeleteButton": {
                display: "flex",
            },
            "& > #itemEditButton": {
                display: "flex",
            },
        },
        "& > #itemHighlightButton": {
            display: "flex",
        },
        cursor: "default",
        border: "5px solid #4ECDC4",
    },
    secondaryItem: {
        position: "absolute",
        background: "#E0E5FA",
        width: "140px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: 4,
        left: "50%",
        fontsize: "12px",
        boxSizing: "border-box !important" as any,
        "&:hover": {
            zIndex: 9999,
            "& > #itemDeleteButton": {
                display: "flex",
            },
            "& > #itemEditButton": {
                display: "flex",
            },
            "& > #itemHighlightButton": {
                display: "flex",
            },
        },
        cursor: "default",
    },
    secondaryItemHighlighted: {
        position: "absolute",
        background: "#E0E5FA",
        width: "140px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "white",
        fontFamily: "Source Sans 3",
        borderRadius: 4,
        left: "50%",
        fontsize: "12px",
        boxSizing: "border-box !important" as any,
        "&:hover": {
            zIndex: 9999,
            "& > #itemDeleteButton": {
                display: "flex",
            },
            "& > #itemEditButton": {
                display: "flex",
            },
        },
        "& > #itemHighlightButton": {
            display: "flex",
        },
        cursor: "default",
        border: "5px solid #4ECDC4",
    },
    mainItemText: {
        fontSize: "12px",
        padding: "8px",
        fontFamily: "Source Sans 3",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
        display: "inline-block !important",
    },
    secondaryItemText: {
        color: theme.palette.text.primary,
        fontSize: "12px",
        fontFamily: "Source Sans 3",
        padding: "8px",
    },
    itemAddButton: {
        position: "absolute",
        top: 6,
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        left: -10,
        "& svg": {
            fontSize: "16px",
        },
    },
    itemDeleteButton: {
        position: "absolute",
        top: 8,
        width: "20px",
        height: "20px",
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        right: -10,
        "& svg": {
            fontSize: "16px",
        },
    },
    itemEditButton: {
        position: "absolute",
        bottom: -15,
        width: "20px",
        height: "20px",
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        right: -5,
        zIndex: "99 !important",
        "& svg": {
            fontSize: "16px",
        },
    },
    itemHighlightButton: {
        position: "absolute",
        top: -15,
        width: "20px",
        height: "20px",
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        right: -5,
        "& svg": {
            fontSize: "16px",
        },
    },
    itemHighlightedButton: {
        position: "absolute",
        top: -15,
        width: "20px",
        height: "20px",
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        backgroundColor: "#192D4E",
        cursor: "pointer",
        right: -5,
        "& svg": {
            fontSize: "16px",
            color: "#F9C13D",
        },
    },
    headEditButton: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        width: "20px",
        height: "20px",
        display: "none",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        color: theme.palette.primary.main,
        backgroundColor: "#192D4E",
        cursor: "pointer",
        right: -10,
        "& svg": {
            fontSize: "16px",
        },
    },
    headAddButton: {
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
        left: "50%",
        width: "20px",
        height: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#F6E4E4",
        borderRadius: "10000px",
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.info.main,
        cursor: "pointer",
        right: -10,
        "& svg": {
            fontSize: "16px",
        },
    },
}));
